/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2014, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'../lib/@waca/core-client/js/core-client/ui/core/View',
	'./PinsPanel'
], function(View, PinsPanel, ) {

	const PinView = View.extend({

		init: function(options = {}) {
			PinView.inherited('init', this, arguments);

			var params = options.params ? options.params : window.location.search;
			this.viewMode = this.isViewMode(params);
			this.glassContext = options.glassContext;
			this.canvasController = options.canvasController;
			this.dashboardApi = this.canvasController.dashboardApi;
			this.slideout = options.slideout;
		},

		isViewMode: function(params) {
			var viewMode = false;

			var getParam = function(param) {
				return decodeURIComponent((new RegExp('[?|&]' + param + '=' + '([^&;]+?)(&|#|;|$)').exec(params) || [ '', '' ])[1].replace(/\+/g, '%20')) ||
					null;
			};

			var key = getParam('mode');
			if (key && key === 'view') {
				viewMode = true;
			}
			return viewMode;
		},

		getUrl: function() {
			return '/pins';
		},

		render: function() {
			return Promise.all([
				this.dashboardApi.getGlassSvc('.DashboardPinning'),
				this._getDndManager()
			]).then((results) => {
				const dashboardPinningService = results[0];
				const PinsPanelClass = this._getPinsPanelClass();
				this._pinListView = new PinsPanelClass({
					el: this.$el,
					appController: this.appController,
					viewMode: this.viewMode,
					glassContext: this.glassContext,
					canvasController: this.canvasController,
					dndManager: this.dndManager,
					dashboardPinningService: dashboardPinningService,
					smartNamingSvc: this.dashboardApi.getDashboardCoreSvc('.SmartNamingSvc')
				});

				this._pinListView.render();
			});
		},

		_getPinsPanelClass: function() {
			return PinsPanel;
		},

		remove: function() {
			this._pinListView.remove();
			return PinView.inherited('remove', this, arguments);
		},


		shouldUpdateGlass: function() {
			return false;
		},

		_getDndManager: function() {
			if (this.dndManager) {
				return Promise.resolve();
			} else {
				return this.dndManager = this.dashboardApi.getFeature('DashboardDnd.internal');
			}
		}
	});
	return PinView;
});
